import { Directive, ElementRef, HostListener, Input, Renderer2 } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appArabicToEnglish]',
  standalone: true,
})
export class ArabicToEnglishDirective {
  constructor(private el: ElementRef,private ngControl: NgControl) {}

  @HostListener('input', ['$event']) onInput(event: Event): void {
    const inputValue = (event.target as HTMLInputElement).value;
    const convertedValue = this.convertArabicToEnglish(inputValue);
    this.el.nativeElement.value = convertedValue;
    this.ngControl.control?.setValue(convertedValue, { emitEvent: false });
  }

  private convertArabicToEnglish(value: string): string {
    const arabicNumerals = '٠١٢٣٤٥٦٧٨٩';
    const arabicComma = '،';
    const englishNumerals = '0123456789';
    const englishComma = ',';

    for (let i = 0; i < arabicNumerals.length; i++) {
      value = value.replace(new RegExp(arabicNumerals[i], 'g'), englishNumerals[i]);
    }
    // Replace Arabic comma with English comma
    value = value.replace(new RegExp(arabicComma, 'g'), englishComma);
    value = value.replace(/,/g, '');

    return value;
  }
}

@Directive({
  selector: '[appNumberFormat]',
  standalone: true,
})
export class NumberFormatDirective {
  @Input() conditionToFormat: boolean = false;
  @Input() mode: string = "decimal";
  constructor(private el: ElementRef,private ngControl: NgControl) {}

  @HostListener('input', ['$event']) onInput(event: any) {
    const input = event.target;
    let value = input.value;
    const sanitizedValue = value.replace(/[^\d٠-٩.]/g, '');
    // Replace Arabic numerals with standard English numerals
    value = sanitizedValue
      .replace(/٠/g, '0')
      .replace(/١/g, '1')
      .replace(/٢/g, '2')
      .replace(/٣/g, '3')
      .replace(/٤/g, '4')
      .replace(/٥/g, '5')
      .replace(/٦/g, '6')
      .replace(/٧/g, '7')
      .replace(/٨/g, '8')
      .replace(/٩/g, '9');

      if(this.conditionToFormat)
      {
        let sanitizedValue :any;
        if(this.mode =='number')
        {
          sanitizedValue = value.replace(/\D/g,'');
        }
        else{
          sanitizedValue = value.replace(/[^\d.]/g, '');
          sanitizedValue = sanitizedValue.replace(/\.{2,}/g, '.');
        }
        // const numericValue: number = parseFloat(value.replace(/\D/g,''));
        //const sanitizedValue = value.replace(/[^\d.]/g, '');

        if (sanitizedValue.endsWith(".0")) {
          // Convert the string to a number and round it to the nearest integer
          //this.convertedNumber = Math.round(parseFloat(this.inputString));
          const numericValue = sanitizedValue;
          this.ngControl.control?.setValue(!isNaN(numericValue) ? numericValue : null, { emitEvent: false });
        } else {
          // If not, just parse the string without rounding
          const numericValue = sanitizedValue.endsWith('.') ? sanitizedValue :  parseFloat(sanitizedValue);
          this.ngControl.control?.setValue(!isNaN(numericValue) ? numericValue : null, { emitEvent: false });
        }

        //const numericValue = sanitizedValue.endsWith('.') ? sanitizedValue :  parseFloat(sanitizedValue);
       // this.ngControl.control?.setValue(!isNaN(numericValue) ? numericValue : null, { emitEvent: false });
        value = value.replace(/\.{2,}/g, '.');
        if (!isNaN(value) && value !== "" ) {
          if (value.slice(-1) === '.' && !value.slice(0, -1).includes('.')){
            input.value = value;
          }
          else{
            if (sanitizedValue.endsWith(".0"))
            {
              input.value = value.replace(/[^\d.]/g,'');
            }
            else{
              const formattedNumber = parseFloat(value.replace(/[^\d.]/g,'')).toLocaleString();
              if (formattedNumber !='NaN') {
                input.value = formattedNumber;
              }
              else{
                input.value = value;
              }
            }
          }
        }
        else{
          input.value = value;
        }
      }
      else{
        if(this.mode =='number')
        {
          input.value = value.replace(/\D/g,'');
        }
        else{
          value = value.replace(/\.{2,}/g, '.');
          input.value = value;
        }
        this.ngControl.control?.setValue(!isNaN(value) ? value : null, { emitEvent: false });
      }
  }
}


@Directive({
  selector: '[appNumberFormatInEnglish]',
  standalone: true,
})
export class NumberFormatInEnglishDirective {
  constructor(private el: ElementRef,private ngControl: NgControl) {}

  @HostListener('input', ['$event']) onInput(event: any) {
    const input = event.target;
    let value = input.value;
    // Replace Arabic numerals with standard English numerals
    value = value
      .replace(/٠/g, '0')
      .replace(/١/g, '1')
      .replace(/٢/g, '2')
      .replace(/٣/g, '3')
      .replace(/٤/g, '4')
      .replace(/٥/g, '5')
      .replace(/٦/g, '6')
      .replace(/٧/g, '7')
      .replace(/٨/g, '8')
      .replace(/٩/g, '9');
      input.value = value;
  }
}
